module.exports = __webpack_public_path__ + "static/media/minus-circle.6fe09198.svg";